__turbopack_context__.v({
  "backdrop": "styles-module-scss-module__9aJGcq__backdrop",
  "closeButton": "styles-module-scss-module__9aJGcq__closeButton",
  "enter": "styles-module-scss-module__9aJGcq__enter",
  "exit": "styles-module-scss-module__9aJGcq__exit",
  "fade-in": "styles-module-scss-module__9aJGcq__fade-in",
  "fade-out": "styles-module-scss-module__9aJGcq__fade-out",
  "fade-out-80": "styles-module-scss-module__9aJGcq__fade-out-80",
  "image": "styles-module-scss-module__9aJGcq__image",
  "slide-in-from-bottom": "styles-module-scss-module__9aJGcq__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__9aJGcq__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__9aJGcq__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__9aJGcq__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__9aJGcq__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__9aJGcq__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__9aJGcq__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__9aJGcq__slide-out-to-top",
  "zoom-in": "styles-module-scss-module__9aJGcq__zoom-in",
  "zoom-out": "styles-module-scss-module__9aJGcq__zoom-out",
  "zoomBadge": "styles-module-scss-module__9aJGcq__zoomBadge",
});
